import { PlayerCoursePage } from '@hendrx/core/courses';
import { createFileRoute } from '@tanstack/react-router';

import { createRouteGuard } from '@/app/_lib/guards/createRouteGuard';
import { requireAuthenticated } from '@/app/_lib/guards/primitives';

export const Route = createFileRoute('/player/courses/$courseDraftIdentifier/')({
  beforeLoad: createRouteGuard(requireAuthenticated()),
  component: PlayerCoursePage
});
